import React, { useEffect, useState } from 'react';

import SearchWidget from '../../../shared/components/SearchWidget';
import requestModel from '../../../entities/requestModel';
import { MdOutlinePublic } from 'react-icons/md';

const DepartCity = ({ value, dictionary, onChoose, hideIcon = true }) => {
  const [cities, setCities] = useState(0);

  const onOptionChange = (e) => {
    setCities(Number(e.target.value));
  };

  const depart_list = () => {
    return Object.keys(dictionary).map(function (key) {
      return dictionary[key];
    });
  };

  const title =
    value === 99 || value === '99'
      ? `${dictionary[value].name_from}`
      : `из ${dictionary[value].name_from}`;

  const items = depart_list();
  items.sort(function (a, b) {
    if (a.name === 'Без перелета') {
      return -1;
    }
    if (b.name === 'Без перелета') {
      return 1;
    }
    return a.name.localeCompare(b.name);
  });

  const highlightCssClass = value !== requestModel.departure ? 'highlight' : '';
  const wasChange =
    value > 1 && window.location.pathname !== '/' ? true : false;

  function getCountryFlag(countryId) {
    return `https://www.geograftour.com/static/index/img/flags/${countryId.toUpperCase()}.svg`;
  }

  return (
    <SearchWidget
      type="select"
      label="Город вылeта"
      title={title}
      cssClass={`depart ${highlightCssClass}`}
      hasFilter={true}
      items={items}
      dictionary={dictionary}
      value={value}
      buttonDone={false}
      isChanged={wasChange}
      onChoose={onChoose}
      flags={true}
      country={cities}
    >
      <div className="country__switcher">
        <label>
          <input
            value={0}
            name="AllCountries"
            id="0"
            type="radio"
            checked={cities === 0}
            onChange={onOptionChange}
          />
          <MdOutlinePublic />
        </label>
        <label>
          <input
            value={47}
            name="Russia"
            id="47"
            type="radio"
            checked={cities === 47}
            onChange={onOptionChange}
          />
          <img
            alt={'Россия'}
            className="country-flag"
            src={getCountryFlag('RU')}
          />
        </label>
        <label>
          <input
            value={78}
            name="Kazakhstan"
            id="78"
            type="radio"
            checked={cities === 78}
            onChange={onOptionChange}
          />
          <img
            alt={'Казахстан'}
            className="country-flag"
            src={getCountryFlag('KZ')}
          />
        </label>
        <span className="selection"></span>
      </div>
    </SearchWidget>
  );
};
export default DepartCity;
